<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>活动金币配置编辑</span>
        </div>
        <el-form ref="formData" :model="formData" :rules="rules" label-width="100px" class="demo-ruleForm">
          <el-form-item label="等级ID" prop="levelId">
            <el-input v-model.number="formData.levelId" style="width: 400px" />
          </el-form-item>
          <el-form-item label="收集" prop="collect">
            <el-input v-model.number="formData.collect" style="width: 400px" />
          </el-form-item>
          <el-form-item label="打" prop="attack">
            <el-input v-model.number="formData.attack" style="width: 400px" />
          </el-form-item>
          <el-form-item label="偷" prop="steal">
            <el-input v-model.number="formData.steal" style="width: 400px" />
          </el-form-item>
          <el-form-item label="排行榜" prop="rank">
            <el-input v-model.number="formData.rank" style="width: 400px" />
          </el-form-item>
          <el-form-item label="星星兑换" prop="starExchange">
            <el-input v-model.trim="formData.starExchange" style="width: 400px" />
          </el-form-item>
          <el-form-item label="建筑大师" prop="architecture">
            <el-input v-model.number="formData.architecture" style="width: 400px" />
          </el-form-item>
          <el-form-item label="累冲" prop="accumulated_pay">
            <el-input v-model.trim="formData.accumulated_pay" style="width: 400px" />
          </el-form-item>
          <el-form-item label="超级连环礼包" prop="super_serial_pack">
            <el-input v-model.trim="formData.super_serial_pack" style="width: 400px" />
          </el-form-item>
          <el-form-item label="推金币" prop="coin_dozer">
            <el-input v-model.trim="formData.coin_dozer" style="width: 400px" />
          </el-form-item>
          <el-form-item label="超级气球" prop="super_balloon">
            <el-input v-model.trim="formData.super_balloon" style="width: 400px" />
          </el-form-item>
          <el-form-item label="复活彩蛋" prop="easter_egg">
            <el-input v-model.trim="formData.easter_egg" style="width: 400px" />
          </el-form-item>
          <el-form-item label="筛子收入" prop="dice_extra_coin">
            <el-input v-model.trim="formData.dice_extra_coin" style="width: 400px" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('formData')">保存</el-button>
            <el-button @click="resetForm('formData')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getActivityCoinCfgList, updateActivityCoinCfg } from '@/api/config/activity-coin-cfg'
export default {
  name: 'ActivityCoinsEdit',
  data() {
    return {
      formData: {
        'levelId': 0,
        'collect': 0,
        'attack': 0,
        'steal': 0,
        'rank': 0,
        'treasureCollect': 0,
        'treasureReward': 0,
        'treasureBet': 0,
        'starExchange': 0,
        'architecture': 0,
        'accumulated_pay': 0,
        'super_serial_pack': 0,
        'coin_dozer': 0,
        'super_balloon': 0,
        'easter_egg': 0,
        'dice_extra_coin': 0
      },
      rules: {
        levelId: [
          { required: true, message: '请输入等级', trigger: 'blur' }
        ],
        collect: [
          { required: true, message: '请输入收集', trigger: 'blur' }
        ],
        attack: [
          { required: true, message: '请输入打', trigger: 'blur' }
        ],
        steal: [
          { required: true, message: '请输入偷', trigger: 'blur' }
        ],
        rank: [
          { required: true, message: '请输入排行榜', trigger: 'blur' }
        ],
        starExchange: [
          { required: true, message: '请输入星星兑换', trigger: 'blur' }
        ],
        architecture: [
          { required: true, message: '请输入建筑大师', trigger: 'blur' }
        ],
        accumulated_pay: [
          { required: true, message: '请输入累冲', trigger: 'blur' }
        ],
        super_serial_pack: [
          { required: true, message: '请输入超级连环礼包', trigger: 'blur' }
        ],
        coin_dozer: [
          { required: true, message: '请输入推金币', trigger: 'blur' }
        ],
        super_balloon: [
          { required: true, message: '请输入超级气球', trigger: 'blur' }
        ],
        easter_egg: [
          { required: true, message: '请输入复活彩蛋', trigger: 'blur' }
        ],
        dice_extra_coin: [
          { required: true, message: '请输入筛子点数', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    const lv = this.$route.query.id
    if (lv > 0) {
      this.getTables(lv)
    }
  },
  methods: {
    getTables(levelId) {
      getActivityCoinCfgList({ LevelId: levelId }).then(res => {
        if (res.code === 200) {
          this.formData = res.data.list[0]
        } else {
          this.msgError(res.msg)
        }
      })
    },
    submitForm() {
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          if (this.formData.levelId <= 0) {
            this.msgError('等级ID必须大于0')
            return
          }
          const _formData = []
          _formData.push(this.formData)
          const data = JSON.stringify(_formData)
          updateActivityCoinCfg({ data: data }).then(res => {
            if (res.code === 200) {
              this.msgSuccess(res.msg)
              this.$router.push({ path: '/config/activity-coins/index' })
            } else {
              this.msgError(res.msg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>
</style>
